<template>
    <div class="content">
        <el-row>
        <el-col :span="2"><div class="grid-content"></div></el-col>
        <el-col :span="6">
            <div class="grid-content MyPhoto">
                <img class="photoimg" src="../assets/photo1.jpg.webp">
                <p class="info">照片来源：YU Xutao（2021.10）</p>
            </div>

        </el-col>
        <el-col :span="6">
            <div class="grid-content MyPhoto">
                <img class="photoimg" src="../assets/photo2.jpg.webp">
                <p class="info">照片来源：QIN Yixiang & CHEN Chao（2023.12）</p>
            </div>
        </el-col>
        <el-col :span="8">
            <div class="grid-content"></div>
        </el-col>

        <el-col :span="2"><div class="grid-content"></div></el-col>


    </el-row>
        <el-row>
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="6">
                <div class="grid-content"></div>
            </el-col>
            <el-col :span="6">
                <div class="grid-content"></div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content about-content">
                    <h1>关于</h1>
                    <p class="paragraph">
                        龚卿于2019年在浙江大学获得工业设计学士学位，并于2024年获浙江大学计算机科学与技术学院设计学博士学位。2024年入职浙江大学长三角创新中心为博士后。她的研究兴趣主要包括人机交互、传统文化数字化与数字创意设计。
                        <br><br> 当前研究方向聚焦于虚拟现实，重点从工程技术与社会科学的交叉视角探索虚拟现实中的人机交互问题，推动虚拟现实技术与设计研究之间的深度融合。她也持续通过新技术应用和实证研究探索设计新概念，并借助跨学科方法拓展设计学科的影响力。
                        <br><br> 在能力结构方面，她具备视觉传达、产品设计与交互设计等基础设计能力；同时熟悉社会科学常用研究路径与经典文献分析方法。技术实现方面，掌握 C++ 基础开发、基于 C# 的 Unity 项目开发、基于 VUE3 与 SpringBoot 的前后端分离开发，以及 Arduino 平台硬件开发。
                    </p>
                </div>
            </el-col>

            <el-col :span="2"><div class="grid-content"></div></el-col>


        </el-row>
    </div>
</template>

<script>
    export default {
        name: "AboutZh",

    }
</script>

<style scoped>
    .MyPhoto{
        width: 20vw;
        height: 20vw;
    }
    .photoimg {
        max-height:100%;

    }
    .about-content{
        margin: -20px  0 0 40px;
        line-height:25px;
    }
    .paragraph{
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;

    }
    h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        padding-top: 50px;
        border-top: black 1px solid;
    }
    .grid-content {
        min-height: 36px;
        border:none;

    }
    .content{
        margin-top:100px;
    }

    .info{
        font-size: 8px;
        color: #666;
        font-weight: 100;
    }
</style>
